/**
 * @generated SignedSource<<08cc70106e2a36931fc9f864a45b0fd4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type UserRole = "SUPER" | "ADMIN_ALL" | "ADMIN" | "JUDGE" | "CLIENT" | "SAAS_CLIENT" | "%future added value";
export type AdminReportPageContainer_ViewerQuery$variables = {
  searchTerm?: string | null;
};
export type AdminReportPageContainer_ViewerQueryVariables = AdminReportPageContainer_ViewerQuery$variables;
export type AdminReportPageContainer_ViewerQuery$data = {
  readonly viewer: {
    readonly role: UserRole;
    readonly sites: {
      readonly nodes: ReadonlyArray<{
        readonly id: string;
        readonly name: string;
      } | null> | null;
    };
  };
};
export type AdminReportPageContainer_ViewerQueryResponse = AdminReportPageContainer_ViewerQuery$data;
export type AdminReportPageContainer_ViewerQuery = {
  variables: AdminReportPageContainer_ViewerQueryVariables;
  response: AdminReportPageContainer_ViewerQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "searchTerm"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "role",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 500
    },
    {
      "kind": "Variable",
      "name": "searchTerm",
      "variableName": "searchTerm"
    }
  ],
  "concreteType": "SiteConnection",
  "kind": "LinkedField",
  "name": "sites",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Site",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AdminReportPageContainer_ViewerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AdminReportPageContainer_ViewerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v3/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0261b88933e054524a8f1c617a630c54",
    "id": null,
    "metadata": {},
    "name": "AdminReportPageContainer_ViewerQuery",
    "operationKind": "query",
    "text": "query AdminReportPageContainer_ViewerQuery(\n  $searchTerm: String\n) {\n  viewer {\n    role\n    sites(first: 500, searchTerm: $searchTerm) {\n      nodes {\n        id\n        name\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "f7c8e4a38269162f140dc1b191879e55";

export default node;
